"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converter of PromotionAreaBinding.
 * @author OPt
 */


var PromotionAreaBindingConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PromotionAreaBindingConverter, _DataObjectConverter_);

  function PromotionAreaBindingConverter() {
    _classCallCheck(this, PromotionAreaBindingConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionAreaBindingConverter).apply(this, arguments));
  }

  return PromotionAreaBindingConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PromotionAreaBindingConverter = PromotionAreaBindingConverter;